// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-alpine {
  --ag-borders: none;
  --ag-borders-secondary: solid 1px;
  --ag-header-background-color: #0b203b;
  --ag-background-color: #f5f5f5;
  --ag-header-foreground-color: var(--color-white);
  --ag-row-height: 30px;
  --ag-odd-row-background-color: #f5f5f5;
}

.ag-theme-quartz {
  --ag-header-background-color: #0b203b;
  --ag-background-color: #f5f5f5;
  --ag-header-foreground-color: var(--color-white);
  --ag-row-height: 48px;
  --ag-odd-row-background-color: #fff;
  --ag-header-height: 48px;
  --ag-borders: none;
  --ag-borders-secondary: solid 1px;
  --ag-border-color: #b3b3b3;
}

.ag-theme-alpine .ag-paging-panel {
  background: var(--color-bg-page) !important; /* matches the page, bar disappears */
  border-top: none !important;
  color: var(--color-text-dark);
}

.ag-theme-alpine .ag-paging-button .ag-icon {
  color: var(--color-primary-green); /* gold arrows */
}

.ag-theme-alpine .ag-root-wrapper-body {
  border: 1px solid #b3b3b3;
}

.ag-theme-alpine .ag-root-wrapper-body {
  border: 1px solid #b3b3b3;
}

.ag-theme-alpine .ag-root-wrapper {
  border: none !important; /* removes the box around rows + pagination */
}

.ag-pinned-left-header {
  z-index: 3;
  background-color: #0b203b;
  overflow: visible;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  border-right: 1px solid #b3b3b3 !important;
  border-bottom: 1px solid #b3b3b3 !important;
}

.ag-cell.ag-cell-not-inline-editing.ag-cell-last-left-pinned {
  border-right: 2px solid #b3b3b3 !important;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after,
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  left: -25px !important;
}

.ag-row {
  cursor: pointer;
}

.ag-header {
  min-height: 0px;
}

.ag-header-row {
  height: 48px !important;
}

.ag-header-row.ag-header-row-floating-filter {
  height: 48px !important;
}

.ag-header-cell-menu-button:hover {
  color: red !important;
}

.ag-header-cell {
  border-right: 1px solid #b3b3b3;
  border: none;
}

.ag-center-cols-container {
  margin: 0px !important;
}

.ag-theme-alpine .ag-root-wrapper {
  font-weight: bold;
  border-bottom: 1px solid #b3b3b3;
  border-left: 1px solid #b3b3b3;
}

.ag-header-cell .ag-icon {
  color: white;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  font-weight: 500;
}

.ag-theme-alpine .ag-row {
  border-left: 1px solid #b3b3b3 !important;
}

.ag-menu {
  margin-top: 30px !important;
  z-index: 9999;
}

.ag-theme-alpine .ag-menu-header {
  display: none !important;
}

.ag-header-cell-menu-button {
  opacity: 1 !important;
}

.ag-theme-alpine .ag-header-cell-menu-button {
  opacity: 1 !important;
}

.ag-icon-filter {
  color: #1562ba !important;
}

.ag-theme-alpine .ag-header-cell,
.ag-theme-alpine .ag-header-group-cell {
  padding: 0 0.5rem;
}

.ag-theme-alpine .ag-ltr .ag-floating-filter-button {
  margin-left: 5px !important;
}

#floatingActiveFilter {
  align-items: center;
  display: flex;
  width: 100%;
}

.custom-tooltip {
  width: 150px;
  height: 70px;
  border: 1px solid cornflowerblue;
  overflow: hidden;
  position: absolute;
  background-color: white;
}

.covering_store:before {
  font-style: normal;
  font-size: 1.15rem;
  content: "\\f0c8";
  font-family: "Font Awesome 6 Free";
  font-weight: 400;
}

.covering_store_checked:before {
  font-style: normal;
  font-size: 1.15rem;
  color: var(--color-primary-orange);
  content: "\\f14a";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}

.ag-theme-alpine .ag-ltr .ag-header-select-all {
  margin-left: 3px; /*11px; */
}

.ag-theme-alpine .ag-header-cell,
.ag-theme-alpine .ag-header-group-cell {
  overflow: visible;
}

#react-select-5-listbox {
  z-index: 11 !important;
}

.ag-floating-filter-full-body {
  overflow: visible;
}

.ag-header-container {
  z-index: 2;
}

.ag-menu.ag-ltr.ag-popup-child {
  z-index: 2;
}

.css-4ljt47-MenuList {
  overflow: auto !important;
}

.css-319lph-ValueContainer,
.css-319lph-ValueContainer div {
  overflow: hidden !important;
}

.ag-header .ag-header-cell-label {
  overflow: hidden;
}

.input.form-control.form-select.checkboxDropdownFilter {
  padding: 3px 28px 2px 3px;
}

.ag-selection-checkbox {
  height: 25px !important;
}

.ag-theme-alpine .ag-row-even {
  background-color: #F3F8FF !important;
  border-color: #efeff8 !important;
}

.ag-theme-alpine .ag-row-odd {
  background-color: #fff !important;
}

.ag-theme-alpine .ag-row-even .ag-cell {
  border-color: #efeff8 !important;
}

.ag-theme-alpine .ag-row-odd .ag-cell {
  border-color: #fff !important;
}

.ag-theme-alpine .ag-row {
  border-left: 1px solid #b3b3b3 !important;
}

.ag-theme-alpine .ag-cell {
  padding: 0 0.5rem;
}

.greyOutIcon:before {
  font-style: normal;
  font-size: 1rem;
  background-color: #9d9d9d;
  color: #ffffff;
  border-radius: 3px;
  padding: 0px 3px;
  content: "\\f00d";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}

.ag-theme-alpine .not-current-row {
  background-color: #ffe6ef !important;
}

.ag-theme-quartz .ag-side-bar {
  background-color: #fff;
  border-left: 1px solid #b3b3b3;
}

.ag-theme-quartz .ag-tool-panel-wrapper {
  background-color: #fff;
}

.ag-theme-quartz .ag-filter-toolpanel-header {
  display: block !important;
  background-color: var(--color-primary-orange);
  color: white;
  padding: 10px;
  font-weight: bold;
  font-size: 14px;
}

.ag-theme-quartz .ag-filter-toolpanel-instance {
  margin-bottom: 5px;
  border-bottom: 1px solid #e0e0e0;
}

.ag-theme-quartz .ag-filter-toolpanel-instance-header {
  background-color: #f5f5f5;
  padding: 8px 10px;
  cursor: pointer;
  font-weight: 500;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

.ag-theme-quartz .ag-filter-toolpanel-instance-header:hover {
  background-color: #e8e8e8;
}

.ag-theme-quartz .ag-column-panel {
  background-color: #fff;
}

.ag-theme-quartz .ag-side-button {
  background-color: var(--color-primary-orange);
  color: white;
  border: none;
}

.ag-theme-quartz .ag-side-button:hover {
  background-color: #666666;
}

.ag-theme-quartz .ag-selected .ag-side-button {
  background-color: #555555;
}

#server-side-grid-wrapper {
  --ag-alpine-active-color: var(--color-primary-green);
}
#server-side-grid-wrapper .ag-side-buttons {
  background: var(--color-white) !important;
}
#server-side-grid-wrapper .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-filter,
#server-side-grid-wrapper .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-columns {
  color: var(--color-primary-green) !important;
  font-weight: bolder !important;
}
#server-side-grid-wrapper .ag-side-buttons .ag-side-button-icon-wrapper .ag-side-button-label:hover {
  color: var(--color-primary-green) !important;
  font-weight: bolder !important;
}
#server-side-grid-wrapper .ag-icon-filter {
  color: var(--color-primary-green) !important;
  font-weight: bolder !important;
}
#server-side-grid-wrapper .ag-header-cell-comp-wrapper .ag-header-cell-text {
  color: #FFF !important;
}
#server-side-grid-wrapper .ag-header-cell-comp-wrapper .ag-header-cell-menu-button:hover {
  color: var(--color-primary-green) !important;
}

.table-actions-row {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
  flex-wrap: nowrap;
}

@media (max-width: 768px) {
  .table-actions-row {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-actions-row .btn {
    flex: 0 0 auto;
    min-width: unset !important;
    width: auto !important;
    padding: 6px 10px !important;
    font-size: 13px !important;
    white-space: nowrap;
  }
}
.ag-filter-toolpanel-header,
.ag-filter-toolpanel-group-title,
.ag-column-select-column-label,
.ag-column-select-header {
  color: var(--color-text-dark) !important;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/listview/TableStyle.scss"],"names":[],"mappings":"AAMA;EACE,kBAAA;EACA,iCAAA;EACA,qCAAA;EACA,8BAAA;EACA,gDAAA;EACA,qBAAA;EACA,sCAAA;AAHF;;AAOA;EACE,qCAAA;EACA,8BAAA;EACA,gDAAA;EACA,qBAAA;EACA,mCAAA;EACA,wBAAA;EACA,kBAAA;EACA,iCAAA;EACA,0BAAA;AAJF;;AAMA;EACE,2CAAA,EAAA,qCAAA;EACA,2BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,iCAAA,EAAA,gBAAA;AAHF;;AAKA;EACE,yBAAA;AAFF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,uBAAA,EAAA,6CAAA;AADF;;AAGA;EACE,UAAA;EACA,yBAAA;EACA,iBAAA;AAAF;;AAGA;EAEE,0CAAA;EACA,2CAAA;AADF;;AAIA;EACE,0CAAA;AADF;;AAIA;;;;EAIE,sBAAA;AADF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,+BAAA;EACA,YAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAOA;EACE,iBAAA;EACA,gCAAA;EACA,8BAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAYA;EACE,yCAAA;AATF;;AAcA;EACE,2BAAA;EACA,aAAA;AAXF;;AAcA;EACE,wBAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE,yBAAA;AAXF;;AAcA;;EAEE,iBAAA;AAXF;;AAcA;EACE,2BAAA;AAXF;;AAeA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AAZF;;AAeA;EACE,YAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAbF;;AAkBA;EACE,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAfF;;AAmBA;EACE,gBAAA,EAAA,SAAA;AAhBF;;AAqBA;;EAEE,iBAAA;AAlBF;;AAqBA;EACE,sBAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AA8BA;EACE,UAAA;AA3BF;;AA8BA;EACE,UAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA8BA;;EAEE,2BAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA+BA;EACE,uBAAA;AA5BF;;AA0CA;EACE,oCAAA;EACA,gCAAA;AAvCF;;AA0CA;EACE,iCAAA;AAvCF;;AA0CA;EACE,gCAAA;AAvCF;;AAyCA;EACE,6BAAA;AAtCF;;AAyCA;EACE,yCAAA;AAtCF;;AAwCA;EACE,iBAAA;AArCF;;AAwCA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,oCAAA;AArCF;;AA2CA;EACE,sBAAA;EACA,8BAAA;AAxCF;;AA4CA;EACE,sBAAA;AAzCF;;AA6CA;EACE,yBAAA;EACA,6CAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,gCAAA;AA1CF;;AA6CA;EACE,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;AA1CF;;AA6CA;EACE,yBAAA;AA1CF;;AA8CA;EACE,sBAAA;AA3CF;;AA+CA;EACE,6CAAA;EACA,YAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,yBAAA;AA5CF;;AA+CA;EACE,yBAAA;AA5CF;;AAmDA;EAEE,oDAAA;AAjDF;AA0DE;EACE,yCAAA;AAxDJ;AA2DE;;EAEE,4CAAA;EACA,8BAAA;AAzDJ;AA4DE;EACE,4CAAA;EACA,8BAAA;AA1DJ;AA6DE;EACE,4CAAA;EACA,8BAAA;AA3DJ;AA8DE;EACE,sBAAA;AA5DJ;AAgEA;EACE,4CAAA;AA9DF;;AAqFA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAlFF;;AAqFA;EACE;IACE,gBAAA;IACA,iCAAA;EAlFF;EAqFA;IACE,cAAA;IACA,2BAAA;IACA,sBAAA;IACA,4BAAA;IACA,0BAAA;IACA,mBAAA;EAnFF;AACF;AAqFE;;;;EAIE,wCAAA;AAnFJ","sourcesContent":["@import \"~ag-grid-community/dist/styles/ag-grid.css\";\r\n@import \"~ag-grid-community/dist/styles/ag-theme-alpine.css\";\r\n// https://www.ag-grid.com/react-data-grid/themes-customising/\r\n\r\n\r\n// Alpine theme (existing tables) - v31 uses CSS variables\r\n.ag-theme-alpine {\r\n  --ag-borders: none;\r\n  --ag-borders-secondary: solid 1px;\r\n  --ag-header-background-color: #0b203b;\r\n  --ag-background-color: #f5f5f5;\r\n  --ag-header-foreground-color: var(--color-white);\r\n  --ag-row-height: 30px;\r\n  --ag-odd-row-background-color: #f5f5f5;\r\n}\r\n\r\n// Quartz theme (Material Design icons) - v31+\r\n.ag-theme-quartz {\r\n  --ag-header-background-color: #0b203b;\r\n  --ag-background-color: #f5f5f5;\r\n  --ag-header-foreground-color: var(--color-white);\r\n  --ag-row-height: 48px;\r\n  --ag-odd-row-background-color: #fff;\r\n  --ag-header-height: 48px;\r\n  --ag-borders: none;\r\n  --ag-borders-secondary: solid 1px;\r\n  --ag-border-color: #b3b3b3;\r\n}\r\n.ag-theme-alpine .ag-paging-panel {\r\n  background: var(--color-bg-page) !important;   /* matches the page, bar disappears */\r\n  border-top: none !important;\r\n  color: var(--color-text-dark);\r\n}\r\n\r\n.ag-theme-alpine .ag-paging-button .ag-icon {\r\n  color: var(--color-primary-green);             /* gold arrows */\r\n}\r\n.ag-theme-alpine .ag-root-wrapper-body {\r\n  border: 1px solid #b3b3b3;\r\n}\r\n.ag-theme-alpine .ag-root-wrapper-body {\r\n  border: 1px solid #b3b3b3;\r\n}\r\n\r\n.ag-theme-alpine .ag-root-wrapper {\r\n  border: none !important;       /* removes the box around rows + pagination */\r\n}\r\n.ag-pinned-left-header {\r\n  z-index: 3;\r\n  background-color: #0b203b;\r\n  overflow: visible;\r\n}\r\n\r\n.ag-theme-alpine .ag-ltr .ag-cell {\r\n  // border: 1px solid #b3b3b3 !important;\r\n  border-right: 1px solid #b3b3b3 !important;\r\n  border-bottom: 1px solid #b3b3b3 !important;\r\n}\r\n\r\n.ag-cell.ag-cell-not-inline-editing.ag-cell-last-left-pinned {\r\n  border-right: 2px solid #b3b3b3 !important;\r\n}\r\n\r\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before,\r\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before,\r\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after,\r\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\r\n  left: -25px !important;\r\n}\r\n\r\n\r\n.ag-row {\r\n  cursor: pointer;\r\n}\r\n\r\n.ag-header {\r\n  min-height: 0px;\r\n}\r\n\r\n.ag-header-row {\r\n  height: 48px !important; // Increased for better header visibility\r\n}\r\n\r\n// Floating filter row\r\n.ag-header-row.ag-header-row-floating-filter {\r\n  height: 48px !important; // Height for filter row\r\n}\r\n\r\n.ag-header-cell-menu-button:hover{\r\n  color:red !important;\r\n}\r\n\r\n.ag-header-cell {\r\n  border-right: 1px solid #b3b3b3;\r\n  border: none;\r\n}\r\n\r\n.ag-center-cols-container {\r\n  margin: 0px !important;\r\n  // width:100% !important\r\n}\r\n\r\n.ag-theme-alpine .ag-root-wrapper {\r\n  font-weight: bold;\r\n  border-bottom: 1px solid #b3b3b3;\r\n  border-left: 1px solid #b3b3b3;\r\n}\r\n\r\n.ag-header-cell .ag-icon {\r\n  color: white;\r\n}\r\n\r\n.ag-theme-alpine .ag-ltr .ag-cell {\r\n  font-weight: 500;\r\n  // word-break:break-word; //for text wrapping\r\n  // white-space: pre-wrap; //for text wrapping\r\n  // line-height: normal !important; //for text wrapping\r\n  // padding-bottom: 9px; //for text wrapping\r\n  // padding-top:5px;\r\n}\r\n\r\n.ag-theme-alpine .ag-row {\r\n  border-left: 1px solid #b3b3b3 !important;\r\n  //height:0px; // for text wrapping\r\n}\r\n\r\n// Filter menu positioning - push it down from header\r\n.ag-menu {\r\n  margin-top: 30px !important; \r\n  z-index:9999\r\n}\r\n\r\n.ag-theme-alpine .ag-menu-header {\r\n  display: none !important;\r\n}\r\n// Always show the menu icon (three lines), not just on hover\r\n.ag-header-cell-menu-button {\r\n  opacity: 1 !important; // Always visible\r\n}\r\n\r\n.ag-theme-alpine .ag-header-cell-menu-button {\r\n  opacity: 1 !important; // Always visible, override theme\r\n}\r\n\r\n.ag-icon-filter {\r\n  color:#1562ba !important\r\n}\r\n\r\n.ag-theme-alpine .ag-header-cell,\r\n.ag-theme-alpine .ag-header-group-cell {\r\n  padding: 0 0.5rem;\r\n}\r\n\r\n.ag-theme-alpine .ag-ltr .ag-floating-filter-button {\r\n  margin-left: 5px !important;\r\n}\r\n\r\n\r\n#floatingActiveFilter {\r\n  align-items: center;\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.custom-tooltip {\r\n  width: 150px;\r\n  height: 70px;\r\n  border: 1px solid cornflowerblue;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  background-color: white;\r\n}\r\n\r\n.covering_store:before {\r\n  font-style: normal;\r\n  font-size: 1.15rem;\r\n  //color:red;\r\n  content: \"\\f0c8\";\r\n  font-family: \"Font Awesome 6 Free\";\r\n  font-weight: 400;\r\n}\r\n\r\n\r\n\r\n.covering_store_checked:before {\r\n  font-style: normal;\r\n  font-size: 1.15rem;\r\n  color: var(--color-primary-orange);\r\n  content: \"\\f14a\";\r\n  font-family: \"Font Awesome 6 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\n\r\n.ag-theme-alpine .ag-ltr .ag-header-select-all {\r\n  margin-left: 3px;  /*11px; */\r\n  // margin-top: 76px;\r\n  // z-index: 10;\r\n}\r\n\r\n.ag-theme-alpine .ag-header-cell,\r\n.ag-theme-alpine .ag-header-group-cell {\r\n  overflow: visible;\r\n}\r\n\r\n#react-select-5-listbox {\r\n  z-index: 11 !important;\r\n}\r\n\r\n.ag-floating-filter-full-body {\r\n  overflow: visible;\r\n}\r\n\r\n// Remove overflow visible from header to allow horizontal scroll sync\r\n// .ag-header {\r\n//   overflow: visible;\r\n// }\r\n\r\n// .ag-header-viewport {\r\n//   overflow: visible;\r\n// }\r\n\r\n.ag-header-container {\r\n  z-index: 2;\r\n}\r\n\r\n.ag-menu.ag-ltr.ag-popup-child {\r\n  z-index: 2;\r\n}\r\n\r\n.css-4ljt47-MenuList {\r\n  overflow: auto !important;\r\n}\r\n\r\n.css-319lph-ValueContainer,\r\n.css-319lph-ValueContainer div {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.ag-header .ag-header-cell-label {\r\n  overflow: hidden;\r\n}\r\n\r\n.input.form-control.form-select.checkboxDropdownFilter {\r\n  padding: 3px 28px 2px 3px;\r\n}\r\n\r\n//for text wrapping\r\n.ag-selection-checkbox{\r\n  height: 25px !important;;\r\n}\r\n\r\n// .ag-body-viewport::-webkit-scrollbar {\r\n//   width: 7px;\r\n//   background-color: #e0e0e0;\r\n// }\r\n\r\n// .ag-body-viewport::-webkit-scrollbar-thumb {\r\n//   background-color: #3e4957;\r\n//   border-radius: 3px;\r\n\r\n// }\r\n\r\n.ag-theme-alpine .ag-row-even {\r\n  background-color: #F3F8FF !important;\r\n  border-color:#efeff8 !important;\r\n}\r\n\r\n.ag-theme-alpine .ag-row-odd {\r\n  background-color: #fff !important;\r\n  \r\n}\r\n.ag-theme-alpine .ag-row-even .ag-cell {\r\n  border-color:#efeff8 !important;\r\n}\r\n.ag-theme-alpine .ag-row-odd .ag-cell {\r\n  border-color:#fff !important;\r\n}\r\n\r\n.ag-theme-alpine .ag-row {\r\n  border-left: 1px solid #b3b3b3 !important;\r\n}\r\n.ag-theme-alpine .ag-cell {\r\n  padding:0 0.5rem;\r\n}\r\n\r\n.greyOutIcon:before {\r\n  font-style: normal;\r\n  font-size: 1rem;\r\n  background-color: #9d9d9d;\r\n  color: #ffffff;\r\n  border-radius: 3px;\r\n  padding: 0px 3px;\r\n  content: \"\\f00d\";\r\n  font-family: \"Font Awesome 6 Free\";\r\n  font-weight: 900;\r\n}\r\n\r\n.ag-theme-alpine .not-current-row {\r\n  background-color: #ffe6ef !important;\r\n}\r\n\r\n// ===== Sidebar Styling for Quartz Theme =====\r\n\r\n// Sidebar container\r\n.ag-theme-quartz .ag-side-bar {\r\n  background-color: #fff;\r\n  border-left: 1px solid #b3b3b3;\r\n}\r\n\r\n// Tool panel wrapper\r\n.ag-theme-quartz .ag-tool-panel-wrapper {\r\n  background-color: #fff;\r\n}\r\n\r\n// Filter toolpanel styling\r\n.ag-theme-quartz .ag-filter-toolpanel-header {\r\n  display: block !important;\r\n  background-color: var(--color-primary-orange);\r\n  color: white;\r\n  padding: 10px;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n\r\n.ag-theme-quartz .ag-filter-toolpanel-instance {\r\n  margin-bottom: 5px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.ag-theme-quartz .ag-filter-toolpanel-instance-header {\r\n  background-color: #f5f5f5;\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  display: flex !important;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.ag-theme-quartz .ag-filter-toolpanel-instance-header:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n// Column panel styling\r\n.ag-theme-quartz .ag-column-panel {\r\n  background-color: #fff;\r\n}\r\n\r\n// Sidebar buttons\r\n.ag-theme-quartz .ag-side-button {\r\n  background-color: var(--color-primary-orange);\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n.ag-theme-quartz .ag-side-button:hover {\r\n  background-color: #666666;\r\n}\r\n\r\n.ag-theme-quartz .ag-selected .ag-side-button {\r\n  background-color: #555555;\r\n}\r\n\r\n// ===== ServerSideGrid Custom Styles =====\r\n// Use #server-side-grid-wrapper to scope styles only to ServerSideGrid component\r\n// This allows custom styling without affecting existing client-side AG Grid tables\r\n\r\n#server-side-grid-wrapper {\r\n  // Override AG Grid CSS variables for ServerSideGrid only\r\n  --ag-alpine-active-color: var(--color-primary-green);\r\n\r\n  // You can add more custom CSS variable overrides here:\r\n  // --ag-header-background-color: #888888;\r\n  // --ag-background-color: #f5f5f5;\r\n  // --ag-row-height: 48px;\r\n  // --ag-border-color: #b3b3b3;\r\n\r\n  // Sidebar toolpanel styling\r\n  .ag-side-buttons {\r\n    background: var(--color-white) !important;\r\n  }\r\n\r\n  .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-filter,\r\n  .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-columns {\r\n    color:var(--color-primary-green) !important;\r\n    font-weight: bolder !important;\r\n  }\r\n\r\n  .ag-side-buttons .ag-side-button-icon-wrapper .ag-side-button-label:hover {\r\n    color: var(--color-primary-green) !important;\r\n    font-weight: bolder !important;\r\n  }\r\n\r\n  .ag-icon-filter {\r\n    color:var(--color-primary-green) !important;\r\n    font-weight: bolder !important;\r\n  }\r\n  \r\n  .ag-header-cell-comp-wrapper .ag-header-cell-text{\r\n    color:#FFF !important\r\n  }\r\n  \r\n  \r\n.ag-header-cell-comp-wrapper .ag-header-cell-menu-button:hover{\r\n  color:var(--color-primary-green) !important;\r\n}\r\n\r\n  // Custom styles for alpine theme in ServerSideGrid\r\n  // .ag-theme-alpine {\r\n  //   // Add custom alpine theme overrides here\r\n  // }\r\n\r\n  // Custom styles for quartz theme in ServerSideGrid\r\n  // .ag-theme-quartz {\r\n  //   // Add custom quartz theme overrides here\r\n  // }\r\n\r\n  // Custom cell styles for ServerSideGrid\r\n  // .ag-cell {\r\n  //   // Add custom cell styles here\r\n  // }\r\n\r\n  // Custom header styles for ServerSideGrid\r\n  // .ag-header-row {\r\n  //   // Add custom header styles here\r\n  // }\r\n}\r\n.table-actions-row {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-bottom: 6px;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .table-actions-row {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-actions-row .btn {\r\n    flex: 0 0 auto;\r\n    min-width: unset !important;\r\n    width: auto !important;\r\n    padding: 6px 10px !important;\r\n    font-size: 13px !important;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n  .ag-filter-toolpanel-header,\r\n  .ag-filter-toolpanel-group-title,\r\n  .ag-column-select-column-label,\r\n  .ag-column-select-header {\r\n    color: var(--color-text-dark) !important;\r\n  }\r\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
